'use client';

import { produce } from 'immer';
import { FC, ReactNode } from 'react';

import { CarGalleryNavigation } from 'src/constants/constants';
import { storeFactory } from './storeFactory';

type PdpModal =
  | {
      name: 'governmentCharges' | 'purchaseInProgress' | 'carSwitch' | 'enquiry';
    }
  | {
      name: 'features';
      initialTab?: 'features' | 'specifications';
    }
  | {
      name: 'gallery';
      initialState?: CarGalleryNavigation;
    };

interface PdpStoreStateData {
  currentModal: PdpModal | null;
}

interface PdpStoreStateFunctions {
  setCurrentModal: (currentModal: PdpModal | null) => void;
}

const {
  store: pdpStore,
  StoreProvider: PdpStoreProvider,
  useCreateStore: useCreatePdpStore,
} = storeFactory<PdpStoreStateData, PdpStoreStateFunctions>(
  () => ({
    currentModal: null,
  }),
  (set) => ({
    setCurrentModal: (currentModal: PdpModal | null) => {
      set((state) =>
        produce(state, (draft) => {
          draft.currentModal = currentModal;
        }),
      );
    },
  }),
);

export { pdpStore };

export const PdpStore: FC<{ children: ReactNode }> = ({ children }) => {
  const createPdpStore = useCreatePdpStore({});

  return <PdpStoreProvider createStore={createPdpStore}>{children}</PdpStoreProvider>;
};
